"use client";
//#region src/openers/neon/tokens.ts
var e = {
	glow: { role: "accent" },
	grid: { color: "#37e6ff" },
	env: { color: "#b48cff" }
};
//#endregion
export { e as t };

//# sourceMappingURL=tokens-DBlg30G8.js.map